<template>
  <div class="nettdoc-triplechoice">
    <label class="nettdoc-triplechoice__container">
        <input :name="'radio'+randomId" type="radio" value="yes" v-model="storeModel" @change="e => $emit('action', e.target.value)"/>
        <span class="nettdoc-radiotext">{{ $t("Yes") }}</span>
        <span class="nettdoc-checkmark"></span>
    </label>

    <label class="nettdoc-triplechoice__container">
        <input :name="'radio'+randomId" type="radio" value="no" v-model="storeModel" @change="e => $emit('action', e.target.value)"/>
        <span class="nettdoc-radiotext">{{ $t("No") }}</span>
        <span class="nettdoc-checkmark"></span>
    </label>

    <label class="nettdoc-triplechoice__container">
        <input :name="'radio'+randomId" type="radio" value="I don't know" v-model="storeModel" @change="e => $emit('action', e.target.value)"/>
        <span class="nettdoc-radiotext">{{ $t("I don't know") }}</span>
        <span class="nettdoc-checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'TripleChoice',
  data() {
    return {
      storeModel: this.model,
      randomId: Math.random(10)
    }
  },
  props: {
    model: String
  }
}
</script>

<style lang="scss" scoped>
  .nettdoc-triplechoice {
    position: relative;
    display: grid;
    grid-template-columns: 30% 30% auto;
    box-sizing: border-box;
    padding: 0 16px;
    &__container {
      float:left;
      display: block;
      box-sizing: border-box;
      height: 60px;
      position: relative;
      padding-left: 35px;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      color: var(--cool-grey);
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      input {
          position: absolute;
          left: 0;
          opacity: 0;
          visibility: hidden;
          &:checked {
              ~ .nettdoc-checkmark {
                  background: url(../assets/control-radio-check.svg);
              }
              ~ .nettdoc-radiotext {
                  color: var(--charcoal-grey) !important;
              }
              ~ p {
                  visibility: visible;
              }
          }
      }
      .nettdoc-checkmark {
          position: absolute;
          top: 18px;
          left: 0;
          height: 24px;
          width: 24px;
          background: url(../assets/control-radio-null.svg);
          border-radius: 50%;
      }
      .nettdoc-radiotext {
        float: left;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
</style>